document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById("myVideo");
  const playBtn = document.getElementById("videoToggleBtn");
  const muteBtn = document.getElementById("muteToggleBtn");

  if (!video || !playBtn || !muteBtn) return;

  const playIcon = playBtn.querySelector(".play-icon");
  const pauseIcon = playBtn.querySelector(".pause-icon");
  const muteIcon = muteBtn.querySelector(".mute-icon");
  const unmuteIcon = muteBtn.querySelector(".unmute-icon");

  // Play/Pause toggle
  playBtn.addEventListener("click", function () {
    if (video.paused) {
      video.play();
      playIcon.style.display = "none";
      pauseIcon.style.display = "block";
    } else {
      video.pause();
      playIcon.style.display = "block";
      pauseIcon.style.display = "none";
    }
  });

  // Mute/Unmute toggle
  muteBtn.addEventListener("click", function () {
    video.muted = !video.muted;
    if (video.muted) {
      muteIcon.style.display = "block";
      unmuteIcon.style.display = "none";
    } else {
      muteIcon.style.display = "none";
      unmuteIcon.style.display = "block";
    }
  });
});
